import React from "react";
import { ArrowDownRight, Cpu } from "lucide-react";

const HERO_BG =
  "https://images.pexels.com/photos/20688553/pexels-photo-20688553.jpeg";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-end overflow-hidden border-b border-[#2A2A2A]"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/70 to-black" />
      <div className="absolute inset-0 bg-black/40" />

      {/* Top spec bar */}
      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-6 md:px-12 pt-28 md:pt-32">
        <div className="flex justify-center mb-6 md:mb-8">
          <span className="logo-tile p-4 md:p-6">
            <img
              src="https://customer-assets.emergentagent.com/job_toad-factory/artifacts/0sl21so2_1778465183515.png"
              alt="Forge State 3D Manufacturing"
              className="h-48 md:h-64 w-auto"
              data-testid="hero-logo"
            />
          </span>
        </div>
        <div className="flex items-center justify-between border-b border-white/10 pb-3 mb-10">
          <span className="font-mono-ui text-[10px] tracking-[0.3em] text-white/60">
            UNIT_01 · ADDITIVE MFG
          </span>
          <span className="font-mono-ui text-[10px] tracking-[0.3em] text-[#FF5722]">
            STATUS: ONLINE
          </span>
        </div>

        <p className="overline mb-6 reveal" data-testid="hero-overline">
          // Precision Additive Manufacturing &nbsp;—&nbsp; EST. 2019
        </p>
      </div>

      {/* Massive type */}
      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-6 md:px-12">
        <h1
          className="font-display uppercase leading-[0.85] tracking-tight text-white reveal"
          style={{ fontSize: "clamp(3.5rem, 14vw, 14rem)" }}
          data-testid="hero-headline"
        >
          We Print<br />
          <span className="text-[#FF5722]">What You </span>
          <span className="italic font-display">Imagine.</span>
        </h1>
      </div>

      {/* Bottom row */}
      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-6 md:px-12 pb-12 md:pb-16 pt-10">
        <div className="hidden md:flex items-center gap-3 text-white/70 mb-8">
          <Cpu size={18} className="text-[#FF5722]" />
          <span className="font-mono-ui text-[11px] tracking-[0.25em]">
            MAX BUILD VOLUME · 350 × 350 × 350 mm
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <p className="md:col-span-7 font-body text-white/70 text-base md:text-lg max-w-md">
            Forge State 3D Manufacturing is a small-batch additive manufacturing studio. Industrial-grade
            FDM &amp; engineering plastics — printed, finished, and shipped
            from our workshop.
          </p>

          <div className="md:col-span-5 flex flex-col sm:flex-row md:justify-end gap-3">
            <a
              href="#quote"
              className="group inline-flex items-center justify-center gap-2 bg-[#FF5722] hover:bg-white hover:text-black transition-colors text-white font-mono-ui text-xs tracking-[0.25em] uppercase font-bold px-6 py-4"
              data-testid="hero-cta-quote"
            >
              Get a Quote
              <ArrowDownRight size={16} className="group-hover:translate-x-0.5 transition" />
            </a>
            <a
              href="#work"
              className="inline-flex items-center justify-center bg-transparent border-2 border-white/20 hover:border-white text-white font-mono-ui text-xs tracking-[0.25em] uppercase font-bold px-6 py-4 transition-colors"
              data-testid="hero-cta-work"
            >
              See Work
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
